const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "/api";

const API_ENDPOINTS = {
  REGISTER_URL: `${API_BASE_URL}/register/`,
  REFRESH_TOKEN_URL: `${API_BASE_URL}/token/refresh/`,
  LOGIN_URL: `${API_BASE_URL}/token/`,
  CREATE_PROJECT_URL: `${API_BASE_URL}/create_project_card/`,
  UPDATE_PROJECT_URL: (projectId) =>
    `${API_BASE_URL}/update_project/${projectId}/`,
  UPLOAD_FILE_URL: (projectName) =>
    `${API_BASE_URL}/upload_files/${projectName}/`,
  GET_PROJECTS_URL: `${API_BASE_URL}/projects/`,
  GET_FILES_URL: (projectName) =>
    `${API_BASE_URL}/projects/${projectName}/files/`,
  RENAME_FILE_URL: (projectName, fileId) =>
    `${API_BASE_URL}/projects/${projectName}/files/${fileId}/rename/`,
  DELETE_FILE_URL: (projectName, fileId) =>
    `${API_BASE_URL}/projects/${projectName}/files/${fileId}/`,
  SAVE_METADATA_URL: (projectName) =>
    `${API_BASE_URL}/projects/${projectName}/files/metadata/`,
  GET_PROJECT_CARDS_URL: `${API_BASE_URL}/get_project_cards/`,
  DELETE_PROJECT_URL: (projectId) =>
    `${API_BASE_URL}/delete_project/${projectId}/`,
  RUN_QC_URL: `${API_BASE_URL}/run-qc/`,
  SINGLE_CELL_PROCESS_URL: (projectName) =>
    `${API_BASE_URL}/single_cell_process/${projectName}/`,
  GET_GENE_EXPRESSION_URL: (projectName) =>
    `${API_BASE_URL}/get_gene_expression/${projectName}/`,
  TASK_STATUS_URL: (taskId) => `${API_BASE_URL}/task-status/${taskId}/`,
  QC_DOWNLOAD_CSV_URL: (projectName, qcId) =>
  `${API_BASE_URL}/qc/${projectName}/${qcId}/download.csv`,
  ARTIFACT_DOWNLOAD_CSV_URL: (projectName, step, artifactId) =>
  `${API_BASE_URL}/artifacts/${step}/${projectName}/${artifactId}/download.csv`,
  QC_RESAMPLE_URL: (projectName) =>
  `${API_BASE_URL}/qc_resample/${projectName}/`,
  // QC_ROWS_URL: (projectName, qcId) =>
  //   `${API_BASE_URL}/qc/${projectName}/${qcId}/rows`,
  ARTIFACT_ROWS_URL: (projectName, step, artifactId) =>
  `${API_BASE_URL}/${step}/${projectName}/${artifactId}/rows`,
  ANALYSIS_RUNS_URL: (projectName) =>
    `${API_BASE_URL}/projects/${projectName}/runs/`,
  PRECOMPUTED_DEMOS_URL: (projectName) =>
    `${API_BASE_URL}/projects/${projectName}/demos/`,
  ALL_PRECOMPUTED_DEMOS_URL: `${API_BASE_URL}/projects/demos/`,

};

export { API_BASE_URL, API_ENDPOINTS };
